import React, { Component } from 'react';
import * as Constants from '../../common/Global/constants';
import {
    BrowserRouter as Router,
} from 'react-router-dom';
import {getLocalStorageVariables,isEmptyVariable,getThemeSettingsVariables,handleTokenExpiry,hasFeatureAccess} from '../../common/Global/commonFunctions';
import RegularDropdown from '../../common/DropdownMenus/RegularDropdown';
import {TopbarWrapper} from './topbar.style'
import moment from 'moment';
import { DatePicker } from 'antd';
let userDetails = getLocalStorageVariables();
let themeSettings = getThemeSettingsVariables();
class Topbar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showNotification:false,
            componentDidMountFlag:false,
            currentPageNo: 1,
            showLoader:false,
            resultSize:50,
            totalCount:0,
            datalist:[],
            newNotificationCount:0,
            showReminderPopup:false,
            reminderDate:'',
            reminderHour:'00',
            reminderMinute:'00',
            reminderDays:'',
            showCustomReminder:false,
            selectedNotificationId:'',
            reminderSaveLoader:false,
            reminderError:'',
            reminderSuccess:'',
            reminderList:[],
            isReminderListMinimized:false,
            reminderListDismissed:false,
            remindersFetched:false,
            remindAgainItem:null,
            remindAgainDate:null,
        }
        userDetails = getLocalStorageVariables();
        themeSettings = getThemeSettingsVariables();
    }

    componentDidMount(){
        this.getNotifications();
        this.getReminderList();
        // this.connectReminderWebSocket();
    }

    componentWillUnmount(){
        this._wsManualClose = true;
        if(this._wsReconnectTimer) clearTimeout(this._wsReconnectTimer);
        if(this._ws) this._ws.close();
    }

    handleShowNotification = (event) => {
        event.preventDefault();
        this.setState({ showNotification: true }, () => {
            document.addEventListener('click', this.hideNotification);
        });
    }

    hideNotification = () => {
        this.setState({ showNotification: false }, () => {
            document.removeEventListener('click', this.hideNotification);
        });
    }

    onClickAllNotifications = (e) => {
        e.stopPropagation();
        window.location = Constants.URL_NOTIFICATIONS;
    }

    handleOkReminder = (key) => {
        this.setState(prev => ({
            reminderList: prev.reminderList.filter(r => r._key !== key),
            remindAgainItem: prev.remindAgainItem && prev.remindAgainItem._key === key ? null : prev.remindAgainItem,
            remindAgainDate: prev.remindAgainItem && prev.remindAgainItem._key === key ? null : prev.remindAgainDate,
        }));
    }

    handleClearAllReminders = () => {
        this.setState({ reminderList: [], remindAgainItem: null, remindAgainDate: null });
    }

    handleOpenRemindAgain = (item) => {
        this.setState({ remindAgainItem: item, remindAgainDate: null });
    }

    handleCloseRemindAgain = () => {
        this.setState({ remindAgainItem: null, remindAgainDate: null });
    }

    handleRemindAgainDateChange = (date) => {
        this.setState({ remindAgainDate: date ? date.format("YYYY-MM-DD HH:mm:ss") : null });
    }

    handleMinimizeReminderList = (e) => {
        e.stopPropagation();
        this.setState(prev => ({ isReminderListMinimized: !prev.isReminderListMinimized }));
    }

    handleShowReminderPopup = (notificationId) => {
        this.setState({
            showReminderPopup:true,
            reminderDate:'',
            reminderHour:'00',
            reminderMinute:'00',
            reminderDays:'',
            showCustomReminder:false,
            selectedNotificationId:notificationId,
            reminderError:'',
            reminderSuccess:'',
        });
    }

    handleHideReminderPopup = () => {
        this.setState({
            showReminderPopup:false,
            reminderDate:'',
            reminderHour:'00',
            reminderMinute:'00',
            reminderDays:'',
            showCustomReminder:false,
            selectedNotificationId:'',
            reminderError:'',
            reminderSuccess:'',
        });
    }

    handleCustomReminderToggle = () => {
        this.setState(prev => ({
            showCustomReminder: !prev.showCustomReminder,
            reminderDate:'',
            ...(!prev.showCustomReminder ? { reminderHour:'00', reminderMinute:'00', reminderDays:'' } : {}),
            reminderError:'',
        }));
    }

    handleReminderDateChange = (date) => {
        this.setState({ reminderDate: date ? date.format("YYYY-MM-DD HH:mm:ss") : "", reminderError:'' });
    }

    handleReminderHourChange = (item) => {
        this.setState({ reminderHour: item.name, reminderError:'' });
    }

    handleReminderMinuteChange = (item) => {
        this.setState({ reminderMinute: item.name, reminderError:'' });
    }

    handleReminderDaysChange = (e) => {
        this.setState({ reminderDays: e.target.value, reminderError:'' });
    }
    /***************************API CALLS****************************/
    getNotifications = () => {
        fetch(Constants.GetUserNotifications,{
            method: "POST",
            mode:'cors',
            body:new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
                pageNo:this.state.currentPageNo,
                resultsize:this.state.resultSize,
            })
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                this.setState({
                    showLoader:false,
                    componentDidMountFlag:true,
                    datalist:data.data.result,
                    totalCount:data.data.count,
                    newNotificationCount:data.data.newNotificationCount
                })
            }else{
                this.setState({
                    datalist:[],
                    totalCount:0,
                    showLoader:false,
                    componentDidMountFlag:true,
                })
            }
        })
    }

    updateNewUserNotifications = () => {
        if(this.state.newNotificationCount > 0){
            this.setState({
                newNotificationCount:0
            })

            fetch(Constants.UpdateNewUserNotifications,{
                method: "POST",
                mode:'cors',
                body:new URLSearchParams({
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                })
            })
            .then(response => { return response.json(); } )
            .then(data =>
            {
                if(handleTokenExpiry(data.responseCode)) return;
                else if(data.responseCode === Constants.CODE_SUCCESS){
                }else{
                }
            })
        }
    }

    getReminderList = () => {
        fetch(Constants.GetNotificationReminders,{
            method: "POST",
            mode:'cors',
            body:new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
            })
        })
        .then(response => { return response.json(); })
        .then(data => {
            if(handleTokenExpiry(data.responseCode)) return;
            if(data.responseCode === Constants.CODE_SUCCESS){
                const now = moment();
                const dueNow = (data.data.notificationReminderList || [])
                    .filter(r => moment(r.reminderDate).isValid() && moment(r.reminderDate).isSameOrBefore(now))
                    .map((r, i) => ({ ...r, _key: r.notificationId + '_' + r.reminderDate + '_' + i }));

                if(dueNow.length > 0){
                    this.setState({
                        reminderList: dueNow,
                        remindersFetched: true,
                        reminderListDismissed: false,
                    });
                } else {
                    this.setState({ remindersFetched: true });
                }
            }
        })
    }

    connectReminderWebSocket = () => {
        this._wsManualClose = false;
        const ws = new WebSocket(
            Constants.ReminderWebSocketUrl +
            '?email=' + encodeURIComponent(userDetails.email) +
            '&accessToken=' + encodeURIComponent(userDetails.accessToken)
        );
        this._ws = ws;

        ws.onmessage = (event) => {
            try {
                const data = JSON.parse(event.data);
                const reminders = (data.notificationReminderList || (data.data && data.data.notificationReminderList) || [])
                    .map((r, i) => ({ ...r, _key: r.notificationId + '_' + r.reminderDate + '_' + i }));
                if(reminders.length > 0){
                    this.setState({
                        reminderList: reminders,
                        remindersFetched: true,
                        reminderListDismissed: false,
                    });
                }
            } catch(e) {}
        };

        ws.onclose = () => {
            if(!this._wsManualClose){
                // Auto-reconnect after 5s on unexpected disconnect
                this._wsReconnectTimer = setTimeout(() => {
                    this.connectReminderWebSocket();
                }, 5000);
            }
        };

        ws.onerror = () => {
            ws.close();
        };
    }

    handleRemindAgainSave = () => {
        const { remindAgainItem, remindAgainDate } = this.state;
        if(!remindAgainDate || !remindAgainItem) return;
        fetch(Constants.CreateNotificationReminder,{
            method: "POST",
            mode:'cors',
            body:new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
                notificationId:remindAgainItem.notificationId,
                reminderDate:remindAgainDate,
            })
        })
        .then(response => response.json())
        .then(data => {
            if(handleTokenExpiry(data.responseCode)) return;
            if(data.responseCode === Constants.CODE_SUCCESS){
                this.setState(prev => ({
                    reminderList: prev.reminderList.filter(r => r._key !== remindAgainItem._key),
                    remindAgainItem: null,
                    remindAgainDate: null,
                }));
            }
        });
    }

    handleSaveReminder = () => {
        const { reminderHour, reminderMinute, reminderDays, reminderDate, showCustomReminder } = this.state;
        if(!showCustomReminder && reminderHour === '00' && reminderMinute === '00' && isEmptyVariable(reminderDays)){
            this.setState({ reminderError:'Set at least Hour, Minute, or Days.' });
            return;
        }
        if(showCustomReminder && isEmptyVariable(reminderDate)){
            this.setState({ reminderError:'Please select a reminder date.' });
            return;
        }

        let computedReminderDate = '';
        if(showCustomReminder){
            computedReminderDate = reminderDate;
        } else {
            const days = !isEmptyVariable(reminderDays) ? parseInt(reminderDays) : 0;
            computedReminderDate = moment()
                .add(days, 'days')
                .add(parseInt(reminderHour), 'hours')
                .add(parseInt(reminderMinute), 'minutes')
                .seconds(0)
                .format('YYYY-MM-DD HH:mm:ss');
        }

        this.setState({ reminderSaveLoader:true, reminderError:'' });
        fetch(Constants.CreateNotificationReminder,{
            method: "POST",
            mode:'cors',
            body:new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
                notificationId:this.state.selectedNotificationId,
                reminderDate:computedReminderDate,
            })
        })
        .then(response => { return response.json(); })
        .then(data => {
            if(handleTokenExpiry(data.responseCode)) return;
            if(data.responseCode === Constants.CODE_SUCCESS){
                this.setState({ reminderSaveLoader:false }, () => {
                    this.handleHideReminderPopup();
                });
            } else {
                this.setState({
                    reminderSaveLoader:false,
                    reminderError:data.responseMessage,
                });
            }
        })
    }

    render() {
        return(
            <Router>
                <TopbarWrapper
                    topbarBg={themeSettings.topbarBg}
                    iconColor={themeSettings.topbarIconColor}
                    selectedIconBg={themeSettings.topbarSelectedIconBg}
                    badgeTextColor={themeSettings.badgeTextColor}
                    badgeBg={themeSettings.notificationBadgeBg}
                    themeColor={themeSettings.themeColor}
                    themeHoverTextColor={themeSettings.themeHoverTextColor}
                >
                    <div className="menu-icon">
                        <span className="material-icons">menu</span>
                    </div>
                    <div className="spacer"></div>
                    <div className="header-right">
                        <div className="info-header">
                            {/* <div className="contact-suppport-layout">
                                <span className="material-icons">mail</span>
                            </div> */}

                            {/* <div className="info-layout-wrapper">
                                <div className="topbar-info-layout">
                                    <img src="/assets/images/topbar-info.svg" />
                                </div>
                            </div> */}

                            <div onClick={this.handleShowNotification} className="header-notification-wrapper">
                                <div className="header-notification" onClick={this.updateNewUserNotifications}>
                                    {
                                        this.state.newNotificationCount > 0 &&
                                        <div className="noti-badge">
                                            <span>{this.state.newNotificationCount}</span>
                                        </div>
                                    }
                                    <span className="material-icons">notifications</span>
                                </div>

                                {
                                    this.state.showReminderPopup &&
                                    <div className="reminder-popup" onClick={e => e.stopPropagation()}>
                                        <div className="reminder-popup-header">
                                            <p>Set Reminder</p>
                                            <span className="material-icons reminder-close" onClick={this.handleHideReminderPopup}>close</span>
                                        </div>
                                        <div className="reminder-popup-body">
                                            <div className={this.state.showCustomReminder ? 'reminder-fields-disabled' : ''}>
                                                <label>Days</label>
                                                <input
                                                    type="number"
                                                    className="reminder-days-input"
                                                    placeholder="Enter days"
                                                    min="1"
                                                    value={this.state.reminderDays}
                                                    onChange={this.handleReminderDaysChange}
                                                    disabled={this.state.showCustomReminder}
                                                />
                                                <div className="reminder-time-row">
                                                    <div className="reminder-time-col">
                                                        <label>Hour</label>
                                                        <RegularDropdown
                                                            placeholder={this.state.reminderHour}
                                                            dropdownArr={Array.from({length:24},(_,i)=>({name:String(i).padStart(2,'0')}))}
                                                            labelParam="name"
                                                            defaultPlaceholderDropDown="00"
                                                            onDropDownItemClick={this.handleReminderHourChange}
                                                        />
                                                    </div>
                                                    <div className="reminder-time-col">
                                                        <label>Minute</label>
                                                        <RegularDropdown
                                                            placeholder={this.state.reminderMinute}
                                                            dropdownArr={[{name:'00'},{name:'15'},{name:'30'},{name:'45'}]}
                                                            labelParam="name"
                                                            defaultPlaceholderDropDown="00"
                                                            onDropDownItemClick={this.handleReminderMinuteChange}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="reminder-custom-checkbox">
                                                <input
                                                    type="checkbox"
                                                    id="reminderCustomCheck"
                                                    checked={this.state.showCustomReminder}
                                                    onChange={this.handleCustomReminderToggle}
                                                />
                                                <label htmlFor="reminderCustomCheck">Custom Date & Time</label>
                                            </div>
                                            {
                                                this.state.showCustomReminder &&
                                                <>
                                                    <label>Date & Time</label>
                                                    <DatePicker
                                                        showTime={{ format: 'HH:mm' }}
                                                        onChange={this.handleReminderDateChange}
                                                        format={"DD/MM/YYYY HH:mm"}
                                                        value={!isEmptyVariable(this.state.reminderDate) ? moment(this.state.reminderDate) : null}
                                                        disabledDate={(current) => current && current.isBefore(moment().startOf('day'))}
                                                        style={{width:'100%'}}
                                                    />
                                                </>
                                            }
                                            {
                                                !isEmptyVariable(this.state.reminderError) &&
                                                <p className="reminder-error">{this.state.reminderError}</p>
                                            }
                                            {
                                                !isEmptyVariable(this.state.reminderSuccess) &&
                                                <p className="reminder-success">{this.state.reminderSuccess}</p>
                                            }
                                        </div>
                                        <div className="reminder-popup-footer">
                                            <button className="reminder-cancel-btn" onClick={this.handleHideReminderPopup}>Cancel</button>
                                            <button className="reminder-save-btn" onClick={this.handleSaveReminder} disabled={this.state.reminderSaveLoader}>
                                                {this.state.reminderSaveLoader ? <div class="loader-btn mt-2"></div> : 'Save'}
                                            </button>
                                        </div>
                                    </div>
                                }

                                {
                                    this.state.showNotification &&
                                    <div className="notifications-dropdown">
                                        <div className="notifications-dropdown-col">
                                            <div className="notifications-dropdown-header">
                                            <p>Notifications</p>
                                            </div>
                                            <div className="notifications-dropdown-list">
                                            <ul>
                                                {
                                                    !isEmptyVariable(this.state.datalist) &&
                                                    this.state.datalist.map(item => {
                                                        return <li key={item.notificationId} style={{background:item.status==="New"?"#7d3f7611":"#fff"}} className="noti-list-item">
                                                            <a href="javascript:void(0);">
                                                                {/* <img src="/assets/images/default-propic.png" /> */}
                                                                <div className="noti-content">
                                                                    <p 
                                                                    style={{lineHeight:1.4,marginBottom:0}}
                                                                    dangerouslySetInnerHTML={{__html: item.desc}}></p>
                                                                    {/* <p>{item.notificationType+" ["+item.screenName
                                                                    +(isEmptyVariable(item.dataType) || item.screenName.toUpperCase() === item.dataType.toUpperCase()?"]":" > "+item.dataType+"]")}</p> */}
                                                                    <span>{moment(item.createDate, "YYYY-MM-DDTHH:mm:ss.SSSZ").format("DD-MMM-YYYY hh:mm a")}</span>
                                                                </div>
                                                            </a>
                                                            {
                                                                hasFeatureAccess(Constants.FEATURE_NOTIFICATION_REMINDERS) &&
                                                                <a
                                                                    href="javascript:void(0);"
                                                                    className="tool noti-reminder-icon"
                                                                    data-title="Set Reminder"
                                                                    onClick={e => { e.stopPropagation(); this.handleShowReminderPopup(item.notificationId); }}
                                                                >
                                                                    <span className="material-icons">alarm</span>
                                                                </a>
                                                            }
                                                        </li>
                                                    })
                                                }
                                            </ul>
                                            </div>
                                            <div className="notification-all-col">
                                                <a href="javascript:void(0)" onClick={this.onClickAllNotifications}>View All</a>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                            <div className="vertical-line"></div>
                            <div className="info-header-wrapper">
                                <div className="ams-logo">
                                    <img src="/assets/images/sameeksha.png" />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Bottom-right reminder list popup - auto-shown when reminders exist */}
                    {
                        this.state.remindersFetched && !isEmptyVariable(this.state.reminderList) && !this.state.reminderListDismissed &&
                        <div className="reminder-list-fab-wrapper" onClick={e => e.stopPropagation()}>
                            <div className="reminder-list-popup">
                                <div className="reminder-list-popup-header">
                                    <div className="reminder-list-header-left">
                                        <span className="material-icons" style={{fontSize:16,marginRight:6}}>alarm</span>
                                        <span>Reminders</span>
                                        <span className="reminder-count-badge">{this.state.reminderList.length}</span>
                                    </div>
                                    <div className="reminder-list-header-actions">
                                        <span
                                            className="reminder-list-clear-all"
                                            onClick={this.handleClearAllReminders}
                                        >Clear All</span>
                                        <span
                                            className="material-icons reminder-list-minimize"
                                            title={this.state.isReminderListMinimized ? "Expand" : "Minimize"}
                                            onClick={this.handleMinimizeReminderList}
                                        >
                                            {this.state.isReminderListMinimized ? "expand_less" : "remove"}
                                        </span>
                                    </div>
                                </div>
                                {
                                    !this.state.isReminderListMinimized &&
                                    <div className="reminder-list-popup-list">
                                        <ul>
                                            {
                                                this.state.reminderList.map(item => {
                                                    return <li key={item._key} className="reminder-card-item">
                                                        <div className="reminder-card-body">
                                                            <div className="reminder-card-top">
                                                                <span className="reminder-card-name">{item.screenName}</span>
                                                            </div>
                                                            {item.dataType && <p className="reminder-card-desc">{item.dataType}</p>}
                                                            <div className="reminder-card-actions">
                                                                <button
                                                                    className="reminder-again-btn"
                                                                    onClick={() => this.handleOpenRemindAgain(item)}
                                                                >Remind Again</button>
                                                                <button
                                                                    className="reminder-ok-btn"
                                                                    onClick={() => this.handleOkReminder(item._key)}
                                                                >Ok</button>
                                                            </div>
                                                        </div>
                                                    </li>
                                                })
                                            }
                                        </ul>
                                    </div>
                                }
                            </div>
                        </div>
                    }
                    {/* Remind Again separate popup */}
                    {
                        this.state.remindAgainItem &&
                        <div className="remind-again-overlay" onClick={this.handleCloseRemindAgain}>
                            <div className="remind-again-popup" onClick={e => e.stopPropagation()}>
                                <div className="remind-again-popup-header">
                                    <p>Remind Again</p>
                                    <span className="material-icons" style={{fontSize:18,color:'#fff',cursor:'pointer'}} onClick={this.handleCloseRemindAgain}>close</span>
                                </div>
                                <div className="remind-again-popup-body">
                                    <label className="remind-again-label">Select Date &amp; Time</label>
                                    <DatePicker
                                        showTime={{ format: 'HH:mm' }}
                                        format="DD/MM/YYYY HH:mm"
                                        placeholder="Select date & time"
                                        onChange={this.handleRemindAgainDateChange}
                                        disabledDate={current => current && current.isBefore(moment().startOf('day'))}
                                        style={{width:'100%'}}
                                        getPopupContainer={() => document.body}
                                    />
                                </div>
                                <div className="remind-again-popup-footer">
                                    <button className="remind-again-cancel-btn" onClick={this.handleCloseRemindAgain}>Cancel</button>
                                    <button
                                        className="remind-again-save-btn"
                                        disabled={!this.state.remindAgainDate}
                                        onClick={this.handleRemindAgainSave}
                                    >Save</button>
                                </div>
                            </div>
                        </div>
                    }
                </TopbarWrapper>
            </Router>
        );
    }
}

export default Topbar;